import {
  isAfter,
  subMinutes,
  subHours,
  subDays,
  endOfYesterday,
  differenceInMinutes,
  format,
} from "date-fns";

import nl from "date-fns/locale/nl";

class DateFormatingService {
  static TIME_NOTATION = "Humm";

  static FORMAT_OPTIONS = {
    locale: nl,
  };

  static formatToTime = (timestamp) => {
    const date = new Date(+timestamp);

    return format(
      date,
      DateFormatingService.TIME_NOTATION,
      DateFormatingService.FORMAT_OPTIONS
    );
  };

  static formatToTimeLineItemDate = (timestamp) => {
    const date = new Date(+timestamp);

    return format(date, "DD/MM/YYYY", DateFormatingService.FORMAT_OPTIONS);
  };

  static formatToShortDate = (timestamp) => {
    const date = new Date(+timestamp);

    return format(date, "D MMMM YYYY", DateFormatingService.FORMAT_OPTIONS);
  };

  static formatToLongDate = (timestamp) => {
    const date = new Date(+timestamp);

    return format(date, "D MMMM YYYY", DateFormatingService.FORMAT_OPTIONS);
  };

  static formatToLongDateMonth = (month) => {
    const [monthNumber, year] = month.split("-");
    const date = new Date(year, monthNumber - 1);

    const formattedMonth = format(
      date,
      "MMMM YYYY",
      DateFormatingService.FORMAT_OPTIONS
    );

    return formattedMonth.charAt(0).toUpperCase() + formattedMonth.slice(1);
  };

  static formatToTimeAndDate = (timestamp) => {
    const date = new Date(+timestamp);
    const now = new Date();

    if (isAfter(date, subMinutes(now, 5))) {
      return "net binnen";
    }

    if (isAfter(date, subHours(now, 1))) {
      return `${differenceInMinutes(now, date)} min geleden`;
    }

    if (isAfter(date, endOfYesterday())) {
      return format(date, DateFormatingService.TIME_NOTATION);
    }

    if (isAfter(date, subDays(endOfYesterday(), 1))) {
      return `gisteren ${format(date, DateFormatingService.TIME_NOTATION)}`;
    }

    return format(date, "DD/M/YYYY");
  };
}

export default DateFormatingService;
